export const isYoungerThan23 = (birthDate: Date | string) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const birth = new Date(birthDate)
  birth.setHours(0, 0, 0, 0)

  const date23YearsAgo = new Date(today.getFullYear() - 23, today.getMonth(), today.getDate())
  date23YearsAgo.setHours(0, 0, 0, 0)

  return birth > date23YearsAgo
}
